import { Grid } from '@mui/material';
import { Redirect, Route, Switch } from 'react-router-dom';
import { vaBBBEEmodule } from '../../../Component/Common/Constants/routes';
import { useRouteMatch } from '../../../Helpers/RouteMatcher';
import { ApprovedSubmissionsPage } from './ApprovedSubmissionsPage';
import { PendingSubmissionsPage } from './PendingSubmissionsPage';
import { RejectedSubmissionsPage } from './RejectedSubmissionsPage';
import { SimpleTab } from '../../../Component/Common/Components/Tabs/SimpleTab';

export const ScorecardSubmissionManagementPage = () => {
  const routes = [
    `/${vaBBBEEmodule.incoming}/${vaBBBEEmodule.scorecardSubmissions}/pending`,
    `/${vaBBBEEmodule.incoming}/${vaBBBEEmodule.scorecardSubmissions}/accepted`,
    `/${vaBBBEEmodule.incoming}/${vaBBBEEmodule.scorecardSubmissions}/rejected`,
  ]

  const labels = ['Pending', 'Accepted', 'Rejected'];
  const tabsData = routes.map((route, index) => ({
      route,
      label: labels[index]
  }));

  const routeMatch = useRouteMatch(routes);
  const currentTab = routeMatch?.path;
  const currentTabIndex = routes.findIndex(route => route === currentTab);

  const handleRedirect = () => {
    if (currentTabIndex === -1) {
      return <Redirect to={routes[0]} />;
    }
    return null;
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} mb={1}>
            <SimpleTab currentTab={currentTab} tabsData={tabsData}/>
        </Grid>
        <Grid item xs={12}>
          <Switch>
            {handleRedirect()}
            <Route path={routes[0]}>
              <PendingSubmissionsPage />
            </Route>
            <Route path={routes[1]}>
              <ApprovedSubmissionsPage />
            </Route>
            <Route path={routes[2]}>
              <RejectedSubmissionsPage />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </>);
}